export default __webpack_public_path__ + "static/media/JoeCrashScrape.795ac851.jpg";